import { default_face_color } from '@phi/constants';
import { reactive, ref } from 'vue';
import { color_parser } from './color-parser';

export const selected_color = ref(undefined as undefined | string);

export const showing_color_picker = ref(false);

export const color_picker_position = reactive({ bottom: 0, left: 0 });

export function show_color_picker(e: MouseEvent | PointerEvent) {
    showing_color_picker.value = true;
    if (e.target instanceof HTMLElement) {
        const rect = e.target.getBoundingClientRect();
        color_picker_position.bottom = Math.min(window.innerHeight - 350, window.innerHeight - rect.top);
        color_picker_position.left = rect.right;
    }
}

export function hide_color_picker() {
    showing_color_picker.value = false;
}

/** available colours for the colour picker
 *
 * initialise with the pico-8 colours
 */
export const palette = reactive([
    '#5F574F',
    '#1D2B53',
    '#7E2553',
    '#008751',
    '#AB5236',
    '#FFF1E8',
    '#FF004D',
    '#52F2B8',
    '#FFEC27',
    '#00E436',
    '#29ADFF',
    '#83769C',
    '#FF77A8',
    '#FFCCAA',
]);

export function add_to_palette(x: string) {
    if (x === color_parser(default_face_color) || palette.includes(x))
        return;
    palette.unshift(x);
    palette.pop();
}
